export function populateCommentCommentContainer(id, commentContainerCode, position) {
    var container = $("#comment_" + id + ".display_comment").find(".comment_comments");
    switch (position) {
        case "pre":
            container.prepend(commentContainerCode);
            break;
        case "past":
        default:
            container.append(commentContainerCode);
    }
}